import React from 'react'
import { Col, Container, Row } from 'react-grid-system'

import './FaqContainer.scss'
import StringFormat from '../../../../utils/StringFormat'
import { TagPushHome } from 'analytics/home'

const FaqContainer = ({ bank }) => (
    <div className="faq-container">
        <Container className="faq-container__container">
            <Row justify={bank && 'center'}>
                <Col
                    className={`faq-container__column ${bank && 'center'}`}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                >
                    <div className="faq-container__title-wrap">
                        <h2 className="faq-container__title">
                            Central de <br className="faq-container__break" />{' '}
                            Vendas
                        </h2>
                    </div>
                    <h3>Telefone</h3>
                    <strong
                        data-gtm-event-category="alelo:loja-virtual"
                        data-gtm-event-action="clique:rodape"
                        data-gtm-event-label="central-de-vendas:telefone"
                    >
                        {StringFormat.bankPhone(bank)}
                    </strong>
                    <small>(Segunda a sexta, das 9h ás 18h)</small>
                    <br />
                    <h3>Email</h3>
                    <strong
                        data-gtm-event-category="alelo:loja-virtual"
                        data-gtm-event-action="clique:rodape"
                        data-gtm-event-label="central-de-vendas:email"
                    >
                        vendasalelo@alelo.com.br
                    </strong>
                </Col>
                {!bank && (
                    <>
                        <Col
                            className="faq-container__column"
                            xl={4}
                            lg={4}
                            md={4}
                            sm={12}
                        >
                            <div className="faq-container__title-wrap">
                                <h2 className="faq-container__title">
                                    Institucional
                                </h2>
                            </div>
                            <a
                                className="faq-container__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.alelo.com.br/sobre"
                                onClick={() =>
                                    TagPushHome.interactionFooterLink(
                                        'Quem somos'
                                    )
                                }
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:rodape"
                                data-gtm-event-label="institucional:quem-somos"
                            >
                                Quem somos
                            </a>
                            <a
                                className="faq-container__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.alelo.com.br/assessoria"
                                onClick={() =>
                                    TagPushHome.interactionFooterLink(
                                        'Assessoria de imprensa'
                                    )
                                }
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:rodape"
                                data-gtm-event-label="institucional:acessoria-de-imprensa"
                            >
                                Assessoria de imprensa
                            </a>
                            <a
                                className="faq-container__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.alelo.com.br/trabalhe-conosco"
                                onClick={() =>
                                    TagPushHome.interactionFooterLink(
                                        'Trabalhe conosco'
                                    )
                                }
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:rodape"
                                data-gtm-event-label="institucional:fale-conosco"
                            >
                                Trabalhe conosco
                            </a>
                            <a
                                className="faq-container__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.alelo.com.br/politica-privacidade"
                                onClick={() =>
                                    TagPushHome.interactionFooterLink(
                                        'Política de privacidade'
                                    )
                                }
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:rodape"
                                data-gtm-event-label="institucional:politica-de-privacidade"
                            >
                                Política de privacidade
                            </a>
                        </Col>
                        <Col
                            className="faq-container__column"
                            xl={4}
                            lg={4}
                            md={4}
                            sm={12}
                        >
                            <div className="faq-container__title-wrap">
                                <h2 className="faq-container__title">
                                    Principais{' '}
                                    <br className="faq-container__break" />
                                    Dúvidas
                                </h2>
                            </div>
                            <a
                                className="faq-container__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.alelo.com.br/empresas/duvidas-frequentes-loja-alelo"
                                onClick={() =>
                                    TagPushHome.interactionFooterLink(
                                        'Minha empresa pode conceder mais de um benefício?'
                                    )
                                }
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:rodape"
                                data-gtm-event-label="principais-duvidas:minha-empresa-pode-conceder-mais-de-um-beneficio"
                            >
                                Minha empresa pode conceder mais de um
                                benefício?
                            </a>
                            <a
                                className="faq-container__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.alelo.com.br/empresas/duvidas-frequentes-loja-alelo"
                                onClick={() =>
                                    TagPushHome.interactionFooterLink(
                                        'Em caso de falta, a empresa pode reduzir o benefício?'
                                    )
                                }
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:rodape"
                                data-gtm-event-label="principais-duvidas:minha-empresa-pode-conceder-mais-de-um-beneficio"
                            >
                                Em caso de falta, a empresa pode reduzir o
                                benefício?
                            </a>
                            <a
                                className="faq-container__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.alelo.com.br/empresas/duvidas-frequentes-loja-alelo"
                                onClick={() =>
                                    TagPushHome.interactionFooterLink(
                                        'Qual é o mínimo de cartões eu posso comprar?'
                                    )
                                }
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:rodape"
                                data-gtm-event-label="principais-duvidas:qual-e-o-minimo-de-cartoes-que-posso-comprar"
                            >
                                Qual é o mínimo de cartões eu posso comprar?
                            </a>
                            <a
                                className="faq-container__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.alelo.com.br/empresas/duvidas-frequentes-loja-alelo"
                                onClick={() =>
                                    TagPushHome.interactionFooterLink(
                                        'Como cancelo um pedido?'
                                    )
                                }
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:rodape"
                                data-gtm-event-label="principais-duvidas:como-inscrevo-empresas-filiais"
                            >
                                Como cancelo um pedido?
                            </a>
                        </Col>
                    </>
                )}
            </Row>
        </Container>
    </div>
)

export default FaqContainer
